// Temporary (frontend#2; same notice in the landing login modal): after the move to the new platform on
// 2026-10-15 accounts created before it are gone, so a failed login explains
// that and points to registration. Hides itself after the date below; the code
// itself is to be removed by then.
export const MIGRATION_NOTICE_UNTIL = new Date('2026-11-07T00:00:00+03:00');

export const showMigrationNotice = (now = new Date()) => now < MIGRATION_NOTICE_UNTIL;
